import {
  ORDERLOCATIONS_TEMPLATE,
  ORDERLOCATIONS_TEMPLATE_LIST_SUCCESSFUL,
  ORDERLOCATIONS_TEMPLATE_ADD,
  ORDERLOCATIONS_TEMPLATE_ADD_SUCCESSFUL,
  ORDERLOCATIONS_TEMPLATE_DELETE,
  ORDERLOCATIONS_TEMPLATE_SET_ROW_DATA,
  ORDERLOCATIONS_TEMPLATE_SET_EDIT_DATA,
  MODEL_OPEN,
  MODEL_CLOSE,
  API_ERROR,
  SET_PARAMS,
  SELECT_CHANGEVALUE,
  INPUT_CHANGEVALUE,
  LOCATION_IMAGE_TEMPLATE,
  GET_Location_TEMPLATE_ROW_DATA,
  Location_TEMPLATE_ROW_SUCCESSFUL,
  CLEAR_ORDERLOCATION_TEMPLATE_DATA,
  ORDERLOCATIONS_TEMPLATE_EDIT_SUCCESSFUL,
  ORDERLOCATIONS_TEMPLATE_EDIT,
} from "./action.types";

export const getORDERLocationsTemplate = (data) => ({
  type: ORDERLOCATIONS_TEMPLATE,
  payload: { data },
});

export const LocationImageTemplate = (image) => {
  return {
    type: LOCATION_IMAGE_TEMPLATE,
    payload: { image },
  };
};
export const ORDERlocationTemplateListSuccessful = (locations) => ({
  type: ORDERLOCATIONS_TEMPLATE_LIST_SUCCESSFUL,
  payload: locations,
});

export const SelecteChangeValue = ({ key, label, key2, value }) => ({
  type: SELECT_CHANGEVALUE,
  payload: { key, label, key2, value },
});

export const InputChangeValue = ({ key, value }) => ({
  type: INPUT_CHANGEVALUE,
  payload: { key, value },
});

export const ORDERlocationTemplateEdit = (data) => {
  return {
    type: ORDERLOCATIONS_TEMPLATE_EDIT,
    payload: data,
  };
};

export const ORDERlocationTemplateEditSuccessful = (response) => {
  return {
    type: ORDERLOCATIONS_TEMPLATE_EDIT_SUCCESSFUL,
    payload: response,
  };
};

export const ORDERlocationAddTemplate = ({
  data,
  image,
  fileType,
  LoId,
  history,
  model,
}) => ({
  type: ORDERLOCATIONS_TEMPLATE_ADD,
  payload: { data, image, fileType, LoId, history, model },
});

// export const ORDERlocationAdd = ({ data, image, LoId, history, model }) => ({
// 	type: ORDERLOCATIONS_TEMPLATE_ADD,
// 	payload: { data, image, LoId, history, model },
// });

export const locationAddTemplateSuccessful = (response) => ({
  type: ORDERLOCATIONS_TEMPLATE_ADD_SUCCESSFUL,
  payload: response,
});

export const ORDERlocationTemplateRowData = (LocId) => ({
  type: ORDERLOCATIONS_TEMPLATE_SET_ROW_DATA,
  payload: { LocId },
});

export const getOrderLocationTemplateRowData = (id, history) => {
  return {
    type: GET_Location_TEMPLATE_ROW_DATA,
    payload: { LocId: id, history },
  };
};

export const locationRowDataTemplateSuccessful = (response) => ({
  type: Location_TEMPLATE_ROW_SUCCESSFUL,
  payload: response,
});

export const SetEditData = (data) => ({
  type: ORDERLOCATIONS_TEMPLATE_SET_EDIT_DATA,
  payload: data,
});

export const ORDERlocationTemplateDelete = (locId) => ({
  type: ORDERLOCATIONS_TEMPLATE_DELETE,
  payload: { locId },
});

export const model_open = () => ({
  type: MODEL_OPEN,
});

export const model_close = () => ({
  type: MODEL_CLOSE,
});

export const SetParams = (params) => ({
  type: SET_PARAMS,
  payload: params,
});

export const apiError = (error) => ({
  type: API_ERROR,
  payload: error,
});

export const clearOrderLocationTemplateData = () => {
  return {
    type: CLEAR_ORDERLOCATION_TEMPLATE_DATA,
  };
};
